// extracted by mini-css-extract-plugin
export default {"modal":"UserInfoModal_modal__dSgVi","overlay":"UserInfoModal_overlay__FazMm","userInfo":"UserInfoModal_userInfo__OhmRV","closeButton":"UserInfoModal_closeButton__u2a8n"};